import { OperationMonitoringStatistics } from '@6grain/masofa-monolith-api-client/common/model/operationMonitoringStatistics';
import { OrchestrationModuleStatistics } from '@6grain/masofa-monolith-api-client/common/model/orchestrationModuleStatistics';
import { PROCESS_GROUPS, ProcessGroupId } from '@app/pages/admin/orchestration-process-groups.util';

export const OVERVIEW_POLL_MS = 15_000;

export interface OrchestrationModuleCard {
  id: ProcessGroupId;
  labelKey: string;
  icon: string;
  inProgress: number;
  succeeded: number;
  failed: number;
  resultCount: number;
  jobInProgress: number;
  jobSucceeded: number;
  jobFailed: number;
}

export function moduleCardsFromStatistics(
  statistics: OperationMonitoringStatistics | null | undefined,
): OrchestrationModuleCard[] {
  const byId = new Map(
    (statistics?.modules ?? [])
      .filter((row): row is OrchestrationModuleStatistics & { id: string } => !!row.id)
      .map(row => [row.id, row]),
  );
  return PROCESS_GROUPS.map(group => {
    const row = byId.get(group.id);
    return {
      id: group.id,
      labelKey: group.labelKey,
      icon: group.icon,
      inProgress: row?.inProgress ?? 0,
      succeeded: row?.succeeded ?? 0,
      failed: row?.failed ?? 0,
      resultCount: row?.resultCount ?? 0,
      jobInProgress: row?.jobInProgress ?? 0,
      jobSucceeded: row?.jobSucceeded ?? 0,
      jobFailed: row?.jobFailed ?? 0,
    };
  });
}
